import React from "react";

const Header = () => {
  return (
    <div className="header">
      <h1>Are you sad?</h1>
      <p className="heading">I will give you an advice and buy you a cocktail.</p>
    </div>
  )
}

export default Header;